import NumberInfo from './number-info.vue';
export default NumberInfo;


// WEBPACK FOOTER //
// ./src/components/number-info/index.js